// Constants.js
require('dotenv').config();

const env = {
    production:{
      url: {
        API_URL: 'https://uptime.service.247uptime.io/api/v1',
        SOCKET_URL:'https://uptime.service.247uptime.io',
        UPTIME_DEFAULT_URL:'247fn://247uptime.io/',
        RECAPTCHA_URL:"6LcQhFIqAAAAAFg1ItTfeOawgrekEHx2RaXZKQvE",
        COPILOT_URL: "https://chat.service.247uptime.io/api/v1"
      }
    },
    staging:{
      url: {
        API_URL: 'https://be.service.staging.247uptime.io/api/v1',
        SOCKET_URL:'https://be.service.staging.247uptime.io',
        UPTIME_DEFAULT_URL:'247fn://247uptime.io/',
        RECAPTCHA_URL:"6LcY3k0qAAAAACjOl5tUy6-PNPiYPsxoIV7B3art",
        COPILOT_URL: "https://chat.service.staging.247uptime.io/api/v1" 
      }
    },
    stagingHetzner:{
      url: {
        API_URL: 'https://uptime.service.staging.stmesunet.247factorynet.com/api/v1',
        SOCKET_URL:'https://uptime.service.staging.stmesunet.247factorynet.com',
        UPTIME_DEFAULT_URL:'247fn://247uptime.io/',
        RECAPTCHA_URL:"6LcY3k0qAAAAACjOl5tUy6-PNPiYPsxoIV7B3art"   ,
        // COPILOT_URL: "https://chat.service.staging.stmesunet.247factorynet.com/api/v1" 
        COPILOT_URL: "https://chat.service.247uptime.io/api/v1"

      }
    },
    development:{
      url: {
        //API_URL: 'http://localhost:2949/api/v1', 
         API_URL: 'http://localhost:3429/api/v1',
        SOCKET_URL:'http://localhost:3003',
        UPTIME_DEFAULT_URL:'247fn://247uptime.io/',
        RECAPTCHA_URL:"6Lfep1QqAAAAAIBh_9POpSfGAcVGjd6DSswtTbEV"

       }
    }
    
};



//export const config_UPTIME = dev;
//export const config_UPTIME = stag;
/* console.log("q->"+process?.env?.REACT_APP_MODE); */
export const config_UPTIME = env[process.env.REACT_APP_MODE];